import { authorizedGetCall, authorizedPutCall } from "./APIsService";

export const getReports = (
  date = null,
  status = null,
  reportReason = null,
  contentType = null,
  reportBy = null,
  reportAgainst = null,
  actionTakenBy = null,
  search = null
) => {
  return new Promise((resolve, reject) => {
    let url = `reports?`;
    if (date) url += `&date=${date}&`;
    if (status) url += `&status=${status}&`;
    if (reportReason) url += `&reportReason=${reportReason}&`;
    if (contentType) url += `&contentType=${contentType}&`;
    if (reportBy) url += `&reportBy=${reportBy}&`;
    if (reportAgainst) url += `&reportAgainst=${reportAgainst}&`;
    if (actionTakenBy) url += `&actionTakenBy=${actionTakenBy}&`;
    if (search) url += `&searchQuery=${encodeURIComponent(search)}`;

    authorizedGetCall(url)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getReportById = (id) => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`reports/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const resolveReport = (id, action) => {
  return new Promise((resolve, reject) => {
    authorizedPutCall(`reports/${id}`, { action })
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
